import request from '@/api/request'

/**
 * 分页查询课时列表
 * @param
 */
 export const getList = (data) => {
  return request({
    url: '/product/adm/lesperiod/getListPage',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 添加课时
 * @param
 */
 export const addLesperiod = (data) => {
  return request({
    url: '/product/adm/lesperiod/addLesperiod',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 更新课时
 * @param
 */
 export const updateLesperiod = (data) => {
  return request({
    url: '/product/adm/lesperiod/updateLesperiod',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 删除课时
 * @param
 */
 export const delLesperiod = (data) => {
  return request({
    url: '/product/adm/lesperiod/delLesperiod',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 修改课时上下架状态
 * @param
 */
 export const updateShelfFlagSpu = (data) => {
  return request({
    url: '/product/adm/lesperiod/updateShelfFlagSpu',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 修改课时上下架状态
 * @param
 */
 export const getBaseUser = (params) => {
  return request({
    url: 'admin/base/adm/baseUser/page',
    method: 'get',
    params
  })
}

// 根据腾讯云返回视频id获取课时时长
export const getMediaLongByVideoId = (data) => {
  return request({
    url: '/product/adm/lesperiod/getMediaLongByVideoId',
    method: 'post',
    type: 'json',
    data
  })
}
// 修改直播状态
export const updateLesperiodStatus = (data) => {
  return request({
    url: '/product/adm/lesperiod/updateLesperiodStatus',
    method: 'post',
    type: 'json',
    data
  })
}
// 拉取回放
export const playbackLesperiod = (data) => {
  return request({
    url: '/product/adm/lesperiod/playbackLesperiod',
    method: 'post',
    type: 'json',
    data
  })
}
// 重新拉取回放
export const againPlaybackLesperiod = (data) => {
  return request({
    url: '/product/adm/lesperiod/againPlaybackLesperiod',
    method: 'post',
    type: 'json',
    data
  })
}
// 回放列表
export const listLesperiodReply = (data) => {
  return request({
    url: '/product/adm/lesperiodReply/listLesperiodReply',
    method: 'post',
    type: 'json',
    data
  })
}
// 发布回放
export const handlePublishReplay = (data) => {
  return request({
    url: '/product/adm/lesperiodReply/handlePublishReplay',
    method: 'post',
    type: 'json',
    data
  })
}
